import styled, { css } from 'styled-components';
import { FontSize, FontWeight, device, spacing } from 'commons';

export const Main = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;

  .error {
    color: ${({ theme }) => theme.danger_500};
  }
`;

export const ButtonWrapper = styled.div`
  display: flex;
  flex: 1;
  justify-content: flex-end;

  .text {
    max-width: 300px;
  }
`;

export const PostWrapper = styled.div<{ $isColumn?: boolean }>`
  display: flex;
  align-items: center;
  gap: 18px;

  ${({ $isColumn }) =>
    $isColumn &&
    css`
      flex-direction: column;
      align-items: flex-start;
    `}

  @media (max-width: ${device.tablet}px) {
    flex-direction: column;
    align-items: flex-start;
  }
`;

export const PostAction = styled.div`
  width: 100%;
  display: flex;
  flex-flow: row wrap;
  gap: 8px;
`;

export const PostRenew = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  gap: 8px;
`;

export const PostCodeWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 3;
  height: ${spacing.input.height};
  gap: 4px;
  border-radius: 8px;
  padding: 8px;
  background-color: ${({ theme }) => theme.neutral_200};

  @media (max-width: ${device.tablet}px) {
    width: 100%;
    flex: auto;
  }
`;

export const PostInfoWrapper = styled.div<{ $isRow?: boolean }>`
  display: flex;
  flex-direction: column;
  flex: 2;

  ${({ $isRow }) =>
    $isRow &&
    css`
      flex-flow: row wrap;
      flex: auto;
      gap: 4px;
    `}
`;

export const ButtonLink = styled.button`
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: ${FontSize.font12};
  font-weight: ${FontWeight.bold};
  background-color: transparent;
  color: ${({ theme }) => theme.primary_300};
  cursor: pointer;

  &:disabled {
    cursor: not-allowed;
    color: ${({ theme }) => theme.neutral_300};
  }

  svg {
    width: 16px;
    height: 16px;
  }
`;
